var map = {
	"./de-DE.json": [
		827,
		11
	],
	"./en-US.json": [
		307
	],
	"./es-ES.json": [
		828,
		12
	],
	"./fr-FR.json": [
		829,
		13
	],
	"./it-IT.json": [
		830,
		14
	],
	"./ja-JP.json": [
		831,
		15
	],
	"./ko-KR.json": [
		832,
		16
	],
	"./pt-BR.json": [
		833,
		17
	],
	"./ru-RU.json": [
		834,
		18
	],
	"./th-TH.json": [
		835,
		19
	],
	"./tr-TR.json": [
		836,
		20
	],
	"./zh-CN.json": [
		837,
		21
	],
	"./zh-TW.json": [
		838,
		22
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 714;
module.exports = webpackAsyncContext;